import * as React from 'react';
import { logErrorToDatabaseWithStack } from '../../actions/apiActions';
import { showErrorModal } from '../../actions/modalActions';
import { ERROR_SOMETHING_WENT_WRONG } from '../../constants/copy';
import { connect } from 'react-redux';

class ErrorBoundary extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
        this.handleShowErrorModal = this.handleShowErrorModal.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
        logErrorToDatabaseWithStack("ErrorBoundary caught exception: " + error, errorInfo.componentStack)
    }

    handleShowErrorModal(e: any) {
        showErrorModal(ERROR_SOMETHING_WENT_WRONG)
    }

    render() {
        if (this.state.errorInfo) {
            this.props.handleShowErrorModal();
            return (
                this.props.children
            );
        }
        return this.props.children;
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleShowErrorModal: () => dispatch(showErrorModal(ERROR_SOMETHING_WENT_WRONG))
    }
}

export default connect(null, mapDispatchToProps)(ErrorBoundary)